import {
  faCheckCircle,
  faClipboardCheck,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useMemo, useState } from 'react';
import { AudioAssistanceButton } from 'view/components/buttons/AudioAssistanceButton';
import IconButton from 'view/components/buttons/IconButton';

interface SidebarGradeUpdaterProps {
  label: string;
  initialGrade?: number;
  onUpdateGrade: (grade: number) => void;
}

const SidebarGradeUpdater: React.FC<SidebarGradeUpdaterProps> = ({
  label,
  initialGrade = 0,
  onUpdateGrade,
}) => {
  const [grade, setGrade] = useState<number>(initialGrade);

  useEffect(() => setGrade(initialGrade), [initialGrade]);

  const handleUpdateGrade = () => {
    onUpdateGrade(grade);
  };

  const handleGradeChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
    setGrade(Number(event.target.value));
  };

  const originalGrade = useMemo(() => initialGrade, [initialGrade]);

  return (
    <div className="sidebar-content-data">
      <div className="row spaced">
        <div className="row">
          <FontAwesomeIcon icon={faClipboardCheck} />
          <label className="label-small">{label}</label>
          <AudioAssistanceButton text="grade" />
        </div>
        <div className="row" style={{ gap: '2px' }}>
          <input type="number" value={grade} onChange={handleGradeChanged} />
          {grade !== originalGrade && (
            <IconButton
              icon={faCheckCircle}
              color="var(--dark-green)"
              type="transparent"
              onClick={handleUpdateGrade}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default SidebarGradeUpdater;
